export const GOOGLE_OAUTH_CLIENT_ID = '353588935388-gtdkbktgahlhkisd7nas72b5p6vrno4u.apps.googleusercontent.com';
